import type { AttributesCount, Meta } from '../../../../generated/frontend'
import { useBaseMetaTags } from '../../../../shared/hooks/useBaseMetaTags'
import type { AppliedFilterItem } from '../../../../shared/types'
import { useProductListingPageDataLayer } from './useProductListingPageDataLayer'

export const useProductListingPageMetaTags = () => {
  const { getBaseMetaTags } = useBaseMetaTags()
  const { getDataLayerItems } = useProductListingPageDataLayer()

  return {
    getPageMetaTags: ({
      meta,
      imageAlt,
      imageUrl,
      twitterCard,
      attributesCount,
      appliedFilters,
      fullUrl,
      hasVariants,
    }: ProductListingMetaArgs) => [
      ...getBaseMetaTags({ meta, imageAlt, imageUrl, twitterCard }),
      ...getDataLayerItems({ meta, attributesCount, appliedFilters, fullUrl, hasVariants }),
    ],
  }
}

/////// IMPLEMENTATION /////////

type ProductListingMetaArgs = {
  meta: Partial<Meta>
  imageUrl?: string
  imageAlt?: string
  twitterCard?: string
  attributesCount: AttributesCount
  appliedFilters?: AppliedFilterItem[]
  fullUrl?: string
  hasVariants?: boolean
}
